
import React, { Component } from 'react';
import PropTypes, { array } from 'prop-types';
import {
  Button,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip,
  FormGroup,
  Input,
  Table,
  Card,
  CardTitle,
  CardText,
  Tooltip,
  CardHeader
} from 'reactstrap';
import Moment from 'moment';
import momentLocalizer from 'react-widgets-moment';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import DataEmptyState from '../../commons/dataemptystate';
import NetworkEmptyState from '../../commons/networkemptystate';
import Loader from '../../commons/loader';
import Services from './services';
import { PaginationTotal } from '../../commons/controls';
import { ProgressButton } from '../../commons/ProgressButton';
import RFForm from '../../components/Form/RFForm';
import RFField from '../../components/Form/RFField';
import { DatetimePicker } from '../../commons/controls';
import SelectField from '../../components/Form/SelectField'
import isEqual from 'lodash/isEqual';
import 'moment/locale/hu';
import TimeFormatter from '../../commons/TimeFormatter';
import Wysiwyg from '../../components/Wysiwyg/Wysiwyg';
import ToolbarBase from '../../components/Wysiwyg/toolbar/ToolbarBase';
import ToolbarPlaceholderRow from '../../components/Wysiwyg/toolbar/ToolbarPlaceholderRow';
import { parseEditorImage } from '../../commons/utils';
import Lib from '../../commons/lib';
import CustomTooltip from '../../components/Tooltip/CustomTooltip';
import getTooltip from './HirlevelTooltips';
import NumberFormatter from '../../commons/NumberFormatter';

const { removeRedundantZeros } = NumberFormatter;

// momentLocalizer(Moment);

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const grid = 8;

const getListStyle = () => ({
  display: 'flex',
  padding: grid,
  overflowX: 'auto',
  whiteSpace: 'nowrap',
  border: '1px solid #ccc'
});

const getItemStyle = draggableStyle => ({
  // some basic styles to make the items look a bit nicer
  userSelect: 'none',
  padding: grid * 2,
  margin: `0 ${grid}px 0 0`,
  border: '1px',
  // styles we need to apply on draggables
  ...draggableStyle
});

class HirlevelKezeles extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // ['LOAD', 'DATA', 'NETW', 'TABL']
      tableStatus: 'TABL',
      sendStatus: 'LOAD',
      // ['FEL', 'MOD', 'VIEW']
      formType: 'FEL',
      kuldesFormType: 'FEL',
      // DATA
      baseJson: [],
      cimzettekBaseJson: [],
      sendData: [],
      currentId: undefined,
      currentTesztkuldesId: undefined,
      torlesId: undefined,
      evhoOptions: [],
      hirlevelvariables: [],
      kategoriaOptions: [],
      viewObj: {},
      // MODAL UTILS
      modalForm: false,
      modalView: false,
      modalDelete: false,
      modalTestSend: false,
      modalCimzettMegtekines: false,
      saveButtonLoading: false,
      deleteButtonLoading: false,
      modalSendNested: false,

      // FORM VALUES
      formEvho: null,
      formElkuldott: null,
      formTargy: '',
      formKategoria: [],
      value: '',
      valtozok: [],
      helyszinek: [],
      kategoriak: [],
      selectedKategoriak: [],
      disabledCheks: [],
      sendIds: [],
      groupedOptions: [
        // {
        //   label: 'Kultik Ajka',
        //   options: [
        //     { value: 'hirek', label: 'Hirek', rating: 'safe' },
        //     { value: 'heti', label: 'Heti musor', rating: 'good' },
        //   ],
        // },
        // {
        //   label: 'Kultik Csepel',
        //   options: [
        //     { value: 'ujhirek', label: 'Új hírek', rating: 'safe' },
        //     { value: 'akciok', label: 'Akciók', rating: 'good' },
        //   ]
        // },
    ],
    formTesztEmail: '',
    formAutomata: null,
    selectedKategoriak: [],
    cimzettSzam: null,
    hasValue: true,
    kats: [],
    isFiltered: false,
    szurHelyszinekOptions: [],
    szurKategoriakOptions: [],
    szurHelyszin: null,
    szurKategoria: null,
    szurEmail: '',
    isNew: false,
    deletedImages: [],
    };
  }

  componentDidMount() {
    this.selected = false;
  }

  componentDidUpdate(prevProps) {
    if (this.props.active !== prevProps.active) {
      if (this.props.active) {
        this.listHirlevelek(null, null);
        this.getFilters();
      }
    }
  }

  hasRole = (roles, checkKarb) => {
    return this.props.globals.hasRole(roles, checkKarb);
  }

  hasRoleSpec = (roles) => {
    return this.props.globals.hasRoleSpec(roles);
  }

//  componentWillReceiveProps(nextProps) {
//    if (nextProps.type === 'HIRLEVEL') {
//     this.listHirlevelek(null, null, true);
//     this.getFilters();
//      // this.getVariables();
//    }
//  }

  listImages = (callback) => {
    Services.listEditorImages((err,res) => {
      if(!err){
        callback(typeof res === "object" ? res[0] : []);
      }
    });
  }

  addImage = async (file) => {
    const { url, funkcioid } = await parseEditorImage((cb) => Services.uploadEditorImage(file, this.state.currentId, cb));
    this.setState(prev => ({ deletedImages: prev.deletedImages.filter(x => x !== url) }));
    this.setState({ currentId: funkcioid });
    return url;
  }

  removeImage = (node) => {
    const src = node.attrs.src;
    if(src?.startsWith('data:')) return;

    this.setState(prev => ({ deletedImages: [...prev.deletedImages, src] }));
  }

  getFilters = () => {
    let options = [];
    Services.initFilters((err, res) => {
      if (!err) {
        res[0].evho.forEach((e) => {
          options.push(
            <option key={e} value={e}>{Moment(e, 'YYYYMM').format('YYYY. MMMM')}</option>
          );
        });
        this.setState({ evhoOptions: options });
      }
    });
  }

  getVariables = () => {
    Services.initVariables((err, res) => {
      if (!err) {
        let valtozok = [];
        let kategoriaOptions = [];
        res[0].valtozo.forEach((item) => {
          let valtozo = {};
          valtozo.name = item[0];
          valtozo.caption = item[1];
          valtozok.push(valtozo);
        })
        res[0].kategoria.forEach((kat) => {
          kategoriaOptions.push({ label: kat.nev, value: kat.id })
        })
        this.setState({ valtozok: valtozok, kategoriaOptions: kategoriaOptions });
      }
    });
  }

  toggleViewModal = () => {
    this.setState(prevState => ({ modalView: !prevState.modalView }));
  }

  toggleFormModal = () => {
    this.getVariables();
    this.setState(prevState => ({ modalForm: !prevState.modalForm, formKategora: null }));
  }

  handleFormCancel = () => {
    if(this.state.modalForm && this.state.currentId && this.state.formType === 'FEL') {
      Services.deleteEditorImages(this.state.currentId, () => {});
    }
    this.toggleFormModal();
    this.setState({ formAzonosito: null, deletedImages: [] });
  }

  toggleDeleteModal = () => {
    this.setState(prevState => ({ modalDelete: !prevState.modalDelete }));
  }

  toggleSendModal = () => {
    this.setState(prevState => ({ modalSend: !prevState.modalSend, formAutomata: null, selectedKategoriak: [],kats: [] }));
  }

  toggleCimzettCount = () => {
    this.setState(prevState => ({ modalSendNested: !prevState.modalSendNested }));
  }

  toggleCimzettMegtekines = () => {
    this.setState(prevState => ({ modalCimzettMegtekines: !prevState.modalCimzettMegtekines }));
  }

  toggleTesztModal = () => {
    this.setState(prevState => ({ modalTestSend: !prevState.modalTestSend }));
  }

  listHirlevelek = (evho, elkuldve) => {
    this.setState({
      tableStatus: 'LOAD'
    }, () => {
    let eloszuresObj = {}
  
    eloszuresObj.elkuldve = elkuldve;
    eloszuresObj.evho = evho;
    Services.listHirlevelek(eloszuresObj, (err, res) => {
      if (!err) {
        let new_obj = {};
        let newJson = [];
        res[0].forEach((item) => {
          new_obj = item;
          newJson.push(new_obj);
        });
        this.setState({
          tableStatus: res[0].length > 0 ? 'TABL' : 'DATA',
          baseJson: newJson
        });
      } else {
        this.setState({
          tableStatus: 'NETW'
        });
      }
    });
    });
  }

  viewHirlevel = (id) => {
    Services.viewHirlevel(id, (err, res) => {
      if (!err) {
        this.setState({
          viewObj: res[0]
        });
      }
    });
  }

  getHirlevel = (id, isNew) => {
    if (isNew) {
      Services.getHirlevel(id, (err, res) => {
        if (!err) {
          const adatok = res[0];
          let kategoriakOptions = [];
          let kategoria = adatok.kategoria;
          let kategoriak = [];
          kategoria.map((kat => {
            kategoriakOptions.push({ label: kat.nev, value: kat.id })
            if (kat.id == adatok.hirlevel.kategoriaid) {
              kategoriak.push({ label: kat.nev, value: kat.id });
            }
            return kategoriak;
          }))
          this.getVariables();
          this.setState({
            formAzonosito: '',
            currentId: undefined,
            formNev: adatok.hirlevel.nev ? adatok.hirlevel.nev : '',
            formKategoria: kategoriak[0],
            kategoriaOptions: kategoria && kategoriakOptions,
            formTargy: adatok.hirlevel.targy ? adatok.hirlevel.targy : '',
            value: adatok.hirlevel.tartalom ? adatok.hirlevel.tartalom : '',
            modalForm: true
        }
      )}})
    } else {
      Services.getHirlevel(id, (err, res) => {
        if (!err) {
          const adatok = res[0];
          let kategoriakOptions = [];
          let kategoria = adatok.kategoria;
          let kategoriak = [];
          kategoria.map((kat => {
            kategoriakOptions.push({ label: kat.nev, value: kat.id })
            if (kat.id == adatok.hirlevel.kategoriaid) {
              kategoriak.push({ label: kat.nev, value: kat.id }); 
            }
            return kategoriak
          }))
          let valtozok = [];
          adatok.valtozo.forEach((item) => {
          let valtozo = {};
          valtozo.name = item[0];
          valtozo.caption = item[1];
          valtozok.push(valtozo);
        })
          this.setState({
            valtozok: valtozok,
            formAzonosito: adatok.hirlevel.azonosito ? adatok.hirlevel.azonosito : '',
            formNev: adatok.hirlevel.nev ? adatok.hirlevel.nev : '',
            formKategoria: kategoriak[0],
            kategoriaOptions: kategoria && kategoriakOptions,
            formTargy: adatok.hirlevel.targy ? adatok.hirlevel.targy : '',
            value: adatok.hirlevel.tartalom ? adatok.hirlevel.tartalom : '',
            modalForm: true
        });
        }
    })
    }
  }

  isHaveValue = (valueParam) => {
    let value = {...valueParam};
    let kats = JSON.parse(JSON.stringify(this.state.kats));
    let newObj = {}
    if (kats.length === 0) {
      newObj = value;
      newObj.label = value.nev
      if (newObj.khid) {
        if (typeof newObj.khid === "object") {
          newObj.khid.push(value.khid)
        } else {
          let khids = []
          khids.push(value.khid)
          newObj.khid = khids
        } 
        let hids = []
        hids.push(value.hid);
        newObj.hid = hids;
      } else {    
        if (typeof newObj.hid === "object") {
          newObj.hid.push(value.hid)
        } else {
          let hids = []
          hids.push(value.hid)
          newObj.hid = hids
        } 
      }
      this.setState((prevState) => ({ kats: [...prevState.kats, newObj] }));
    } else {
      newObj = value;
      newObj.label = value.nev;
      if (newObj.khid) {
        if (typeof newObj.khid === "object") {
          newObj.khid.push(value.khid)
        } else {
          let khids = [];
          khids.push(value.khid);
          newObj.khid = khids;
        }
        let hids = []
        hids.push(value.hid);
        newObj.hid = hids;
      } else {
        if (typeof newObj.hid === "object") {
          let hids = newObj.hid;
          hids.push(value.hid);
          newObj.hid = hids;
        } else {
          let hids = []
          hids.push(value.hid);
          newObj.hid = hids;
        }
      } 
      this.setState((prevState) => ({ kats: [...prevState.kats, newObj] }));
    } 
  }
  getHirlevelCimzettInit = (id) => {
    Services.getHirlevelCimzettInit(id, (err, res) => {
      if (!err) {
        const { helyszinIdToNevMap, kategoriak: helyszinIdToKategoriaMap } = res[0];
        let kategoriaOptions = Object.keys(helyszinIdToKategoriaMap).map(helyszinId => {
          return { label: helyszinIdToNevMap[helyszinId], hid: helyszinId, options: helyszinIdToKategoriaMap[helyszinId] };
        });
        let selectedKategoriak = Object.values(helyszinIdToKategoriaMap).flat().filter(kategoriak => kategoriak.ckd != 'VAL');
        this.setState({
          selectedKategoriak,
          formAutomata: res[0].utemezettKuldesIdopont ? new Date(res[0].utemezettKuldesIdopont) : null,
          sendData: res[0],
          kategoriak: kategoriaOptions,
          sendStatus: 'TABL',
        });
      } else {
        this.setState({
          sendStatus: 'NETW'
        });
      }
    });
  }

  isAllCheckedByCategory = (idx) => {
    let result = true;
    let newData = JSON.parse(JSON.stringify(this.state.sendData));
    newData[idx].content.forEach((cimzett) => {
      if (!cimzett.cimzett) {
        result = false
      } 
    });

    return result;
  }

  isCheked = (kategoria, idx) => {
    let result = false;
    let counter = 0;
    let newData = JSON.parse(JSON.stringify(this.state.sendData));
    if (kategoria, idx){
      this.state.disabledCheks.forEach((item) => {
        if (item.kategoria === kategoria.name) {
          counter += 1;
        }
        if(counter  === newData[idx].content.length){
        result = true
        }
      })
    }
    return result;
  }

  getCimzettCount = () => {
    const { selectedKategoriak } = this.state;
    let newIds = selectedKategoriak.filter(kategoria => kategoria.ckd != 'KULD').map(kategoria => [kategoria.hid, kategoria.kid]);
      Services.getHirlevelCimzettCount(this.state.currentId, newIds, (err, res) => {
        if (!err) {
          this.setState({ cimzettSzam: res[0] }, () => this.toggleCimzettCount());
        }
      })
  }

  getCimzettekInitFilter = (id) => {
    Services.getCimzettekInitFilter(id, (err, res) => {
      if (!err){
        let szurHelyszinek = [];
        let szurKategoriak = [];
        for (const [key, value] of Object.entries(res[0].helyszin)) {
        szurHelyszinek.push(<option key={key} value={key}>{value}</option>);
        }
        for (const [key, value] of Object.entries(res[0].kategoria)) {
          szurKategoriak.push(<option key={key} value={key}>{value}</option>);
        }
        this.setState({  
          szurHelyszinekOptions: szurHelyszinek,
          szurKategoriakOptions: szurKategoriak,
          currentId: id
        })
      }
    })
  }

  handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value
    });
  }

  isValueArray = (value, submit) => {
    if (submit) {
      if (submit === 'submit') {
        if(typeof value === 'object') {
          return value[0];
        } else {
          return { khid: value };
        }
      }
      if (submit === "helyek") {
        if(typeof value === 'object') {
          return value[0];
        } else {
          return value;
        }
      }
    }
    else {
      if(typeof value === 'object') {
        return value[0].hid;
      } else {
        return value;
      }
    }
  }

  handleKuldesKategoriaChange = (obj) => {
    this.setState((prevState) => {
      let selectedKategoriak = prevState.selectedKategoriak;
      // Ha már be van választva a kategória, akkor törli a listából, egyébként meg hozzáadja
      if (selectedKategoriak.find(kategoriaOld => kategoriaOld == obj))
        selectedKategoriak = selectedKategoriak.filter(kategoriaOld => kategoriaOld != obj);
      else
        selectedKategoriak.push(obj);
      return { selectedKategoriak: selectedKategoriak };
    });
  }

  handleKategoriaTorlesClick = (deleteObj) => {
    let selectedKategoriak = [...this.state.selectedKategoriak];
    selectedKategoriak = selectedKategoriak.filter(kategoria => kategoria.kid != deleteObj.kid || kategoria.ckd == 'KULD');
    this.setState({ selectedKategoriak });
  }

  dateToTimezone = (date) => {
    if (!date || date === '') return null;
    return TimeFormatter.formatIso(date);
  }

  timezoneToDate = (date) => {
    if (!date || date === '') return null;
    return TimeFormatter.formatDateTime(date);
  }
  
  handleDateInputChange = (e) => {
    if (e) {
      this.setState({ 
        formAutomata: new Date(e)
       })
    } else {
      this.setState({ 
        formAutomata: null
       });
    }
    // if (this.state.formKuldesKategoriak.length !== 0) {
    //   this.validateDate('formAutomata', 'automatalabel');
    // }
  }

  handleDateChange = (e,v,type) => {
    if(this.selected) {
      this.selected = false;
      switch (type) {
        case 'FORMIDOZITETTKULDES':
          this.setState({ formAutomata: (Moment(e).startOf('day')) });
          break;
        default:
          break;
      }
    } else {
      switch (type) {
        case 'FORMIDOZITETTKULDES':
          this.setState({ formAutomata: (v === '' ? null : e) });
          break;
        default:
          break;
      }
    }
  }

  handleCheckedInputChange = (e, name) => {
    let newJegy = [];

    this.state.selectedJegy.forEach((jegy) => {
      if (jegy.name === name) {
        newJegy.push({
          name: jegy.name,
          checked: !jegy.checked
        });
      } else {
        newJegy.push({
          name: jegy.name,
          checked: jegy.checked
        });
      }
    });
    this.setState({
      selectedJegy: newJegy
    });
  };

  isCheckedByName = (name) => {
    let result = false;
    this.state.selectedJegy.forEach((jegy) => {
      if (jegy.name === name) {
        result = jegy.checked;
      }
    });
    return result;
  };

  onDragEnd = (result) => {
    let { toolbargroupjegy } = this.state;

    if (result.destination) {
      const items = reorder(
        toolbargroupjegy,
        result.source.index,
        result.destination.index
      );

      this.setState({
        toolbargroupjegy: items
      });
    }

    return '';
  };

  onChange = (value) => {
    this.setState({ value: value });
  };

  handleViewClick = (id) => {
    this.setState({
      formType: 'VIEW',
      currentId: id,
      modalView: true
    }, () => {
      this.viewHirlevel(id);
    });
  }

  handleEditClick = (cell, isNew) => {
    if (isNew) {
      this.setState({
        formType: 'FEL',
        isNew: true
      }, () => {
        this.getHirlevel(cell, isNew);
      });
    } else {
      this.setState({
        formType: 'MOD',
        currentId: cell,
      }, () => {
        this.getHirlevel(cell);
      });
    }
  }

  handleCimzettMegtekintesClick = (cell) => {
    this.getCimzettekInitFilter(cell)
    this.toggleCimzettMegtekines();
  }

  handleDeleteClick = (cell) => {
    this.setState({
      torlesId: cell
    }, () => {
      this.toggleDeleteModal();
    });
  }
  
  handleSendClick = (cell) => {
    this.setState({
      formType: 'MOD',
      currentId: cell,
      modalSend: true,
      sendStatus: 'LOAD',
    }, () => {
      this.getHirlevelCimzettInit(cell);
    });
  }

  handleTesztClick = (cell) => {
    this.setState({
      currentTesztkuldesId: cell,
      tesztkuldesModal: true,
      formTesztEmail: '',
    }, () => {
      this.toggleTesztModal();
    });
  }

  deleteHirlevel = () => {
    this.setState({
      deleteButtonLoading: true
    });
    Services.deleteHirlevel(this.state.torlesId, (err) => {
      if (!err) {
        this.toggleDeleteModal();
        this.listHirlevelek(null, null)
        this.props.globals.addSuccess('Hírlevél sikeresen törölve!');
        this.setState({
          deleteButtonLoading: false
        });
      } else {
        this.setState({
          deleteButtonLoading: false
        });
      }
    });
  }

  emptyOrNull = (data) => {
    if (!data || data === '') return null;
    return data;
  }

  nullToString = (data) => {
    if (!data) return '';
    return data;
  }

  handleNewClick = () => {
    this.setState({
      formType: 'FEL',
      formAzonosito: '',
      formKategoria: [],
      formNev: '',
      formTargy: '',
      currentId: undefined,
      value: ''
    }, () => {
      this.getVariables();
      this.toggleFormModal();
    });
  }

  eloszures = () => {
    const {
      formElkuldott,
      formEvho,
    } = this.state;
    let elkuldott;
    if (formElkuldott) {
      if (formElkuldott === '') {
        elkuldott = null
      } 
        if (formElkuldott === 'true') {
          elkuldott = true
        } if (formElkuldott === 'false') {
          elkuldott = false;
        }
    }
    let evho = formEvho === '' ? null : formEvho;
    this.listHirlevelek(evho, elkuldott);
  }

  renderEloszuresForm = () => {
    const {
      formEvho,
      formElkuldott
    } = this.state;
    return (
      <React.Fragment>
        <RFForm onSubmit={this.eloszures}>
          <div className="row align-items-center">
            <div className="col-md-5">
              <div className="row align-items-center">
                <div className="col-md-4">
                  <Label>Küldés szerint:</Label>
                </div>
                <div className="col-md-8">
                  <RFField
                    type="select"
                    name="formElkuldott"
                    id="formElkuldott"
                    // label="Küldés szerint: "
                    value={formElkuldott}
                    onChange={this.handleInputChange}
                    defaultSelect={<React.Fragment>
                      <option value="">Mind</option>
                      <option value="true">Elküldöttek</option>
                      <option value="false">Nem elküldöttek</option>
                    </React.Fragment>}
                    selectOptions={[]}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-5">
              <div className="row align-items-center">
                <div className="col-md-4">
                  <Label>Dátum szerint:</Label>
                </div>
                <div className="col-md-8">
                  <RFField
                    type="select"
                    name="formEvho"
                    id="formEvho"
                    // label="Dátum szerint: "
                    value={formEvho}
                    onChange={this.handleInputChange}
                    defaultSelect={<option value="">Nincs szűrés</option>}
                    selectOptions={this.state.evhoOptions}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-1" style={{ marginBottom: 5 }}>
              <Button type="submit" color="success">Keresés</Button>
            </div>
          </div>
        </RFForm>
      </React.Fragment>
    );
  }

  renderToolbarHirlevel = () => {
    const toolbarGroups = Object.entries(this.state.hirlevelvariables);

    return toolbarGroups.map((toolbargroup) => {
      let selectable = this.getSelectableByName(toolbargroup[0]);
      let iconName = this.getIconByName(toolbargroup[0]);

      return (
        selectable && (
          <DragDropContext
            onDragEnd={this.onDragEnd}
            key="3233"
            // className={"ow-wysiwyg-toolbar-group"}
          >
            <Droppable
              droppableId="droppable"
              key="464546456486632"
              direction="horizontal"
              style={{ border: '1px solid #ccc!important;' }}
            >
              {(provided, snapshot) => {
                return (
                  <div
                    ref={provided.innerRef}
                    style={getListStyle()}
                    {...provided.droppableProps}
                    {...provided.droppablePlaceholder}
                  >
                    <div style={{ display: '' }}>
                      <Label>Jegyadatok:</Label>
                    </div>
                    {this.state.toolbargrouphirlevel.map((toolbaritem, index) => {
                      return (
                        <Draggable
                          draggableId={toolbaritem.caption}
                          index={index}
                          key={toolbaritem.nam}
                        >
                          {(prov, snap) => {
                            return (
                              <div
                                ref={prov.innerRef}
                                {...prov.draggableProps}
                                {...prov.dragHandleProps}
                                style={getItemStyle(
                                  prov.draggableProps.style
                                )}
                                key={toolbaritem.nam}
                                // className={"ow-wysiwyg-toolbar-item"}
                              >
                                <span
                                  type="text"
                                  name="text"
                                  tag=""
                                  key={toolbaritem.caption}
                                >
                                  <span
                                    id={toolbaritem.code.substring(
                                      2,
                                      toolbaritem.code.length - 1
                                    )}
                                    style={{ width: '100%', height: '100%' }}
                                  >
                                    <i className={iconName} aria-hidden="true">
                                      &nbsp;&nbsp;
                                      {toolbaritem.caption}
                                    </i>
                                  </span>
                                </span>
                                <br />
                                <input
                                  name="checked"
                                  type="checkbox"
                                  style={{ position: 'inherit' }}
                                  onChange={(e) => {
                                    this.handleCheckedInputChange(
                                      e,
                                      toolbaritem.nam
                                    );
                                  }}
                                  checked={this.isCheckedByName(
                                    toolbaritem.nam
                                  )}
                                />
                              </div>
                            );
                          }}
                        </Draggable>
                      );
                    })}
                    {provided.placeholder}
                  </div>
                );
              }}
            </Droppable>
          </DragDropContext>
        )
      );
    });
  };

  renderForm = () => {
    const {
      formNev,
      formKategoria,
      formTargy,
      formAzonosito,
      value,
      formType
    } = this.state;

    const styles = {
      menu: (provided, state) => ({
        ...provided,
        zIndex: '99999',
        opacity: 1
      })
    }
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-6">
            <Label>Azonosító: *</Label>
            <Input
              name="formAzonosito"
              id="formAzonosito"
              type="text"
              required
              disabled={this.state.formType === 'MOD'}
              onChange={this.handleInputChange}
              value={formAzonosito}
            />
          </div>
          <div className="col-md-6">
            <Label>Név: *</Label>
            <Input
              name="formNev"
              id="formNev"
              type="text"
              required
              onChange={this.handleInputChange}
              value={formNev}
            />
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-md-6">
            <SelectField
              label={<>Kategória:<CustomTooltip text={getTooltip('kategoria')} id="kategoriaTT" /></>}
              name="formKategoria"
              id="formKategoria"
              onChange={v => this.setState({formKategoria: v})}
              placeholder={'Válassz kategóriát...'}
              styles={styles}
              options={this.state.kategoriaOptions}
              value={formKategoria}
            />
          </div>
          <div className="col-md-6">
          <Label for="formTargy">Tárgy: *</Label>
            <Input
              type="text"
              name="formTargy"
              id="formTargy"
              value={formTargy}
              style={{ marginBottom: 8 }}
              onChange={this.handleInputChange}
            />
          </div>
        </div>
        <br />
      </React.Fragment>
    );
  }

  renderTartalomForm = () => {
    const { value } = this.state
    return (
      <div className="row" style={{  zIndex: 1 }}>
        <div className="col-md-12">
          <Label>Tartalom: *</Label>
          {this.renderToolbarHirlevel()}
          <Wysiwyg
            key="hirlevel_form_wysiwyg"
            value={value}
            onChange={this.onChange}
            onImageUpload={this.addImage}
            onImageRemove={this.removeImage}
            toolbar={() => 
              <>
                <ToolbarBase />
                <ToolbarPlaceholderRow 
                  icon={<i className='fa fa-user' aria-hidden="true" />}
                  items={this.state.valtozok.map((x) => ({ code: x.name, caption: x.caption }))}
                />
              </>
            }
          />
        </div>
      </div>
    );
  }

  submitForm = () => {
    const {
      currentId,
      formAzonosito,
      formKategoria,
      formNev,
      formTargy,
      value,
      formType,
      isNew
    } = this.state;

    this.setState({
      saveButtonLoading: true
    });
    if (formType === 'FEL') {
      let submitObj = {};
      submitObj.id = this.emptyOrNull(currentId);
      submitObj.azonosito = this.nullToString(formAzonosito);
      submitObj.nev = this.nullToString(formNev);
      submitObj.kategoriaid = formKategoria && (formKategoria.value ?  formKategoria.value : null);
      submitObj.targy = this.nullToString(formTargy);
      submitObj.tartalom = value;
      submitObj.funkcioid = this.emptyOrNull(currentId);
      if (isNew) {
        Services.addHirlevel(submitObj, (err, res) => {
          if (!err) {
            // this.props.globals.addSuccess('Hírlevél sikeresen felvéve!');
            this.setState({
              saveButtonLoading: false
            }, () => {
              this.setState({ currentId: res[0], formType: "MOD_NEW" })
              this.toggleFormModal();
              this.listHirlevelek(null, null)
            });
          } else {
            this.setState({
              saveButtonLoading: false
            });
          }
        });
      } else {
        Services.addHirlevel(submitObj, (err, res) => {
          this.setState({
            saveButtonLoading: false
          });
          if (!err) {
            // this.props.globals.addSuccess('Hírlevél sikeresen felvéve!');
            this.setState({ currentId: res[0], formType: "MOD_NEW" })
            this.toggleFormModal();
            this.listHirlevelek(null, null)
          }
        });
      }
    } else if (formType === 'MOD' || formType === "MOD_NEW") {
      let submitObj = {};
      submitObj.id = this.emptyOrNull(currentId);
      submitObj.nev = this.nullToString(formNev);
      submitObj.kategoriaid = formKategoria && (formKategoria.value ?  formKategoria.value : null);
      submitObj.targy = this.nullToString(formTargy);
      submitObj.tartalom = value;
      Services.editHirlevel(submitObj, (err) => {
        if (!err) {
          this.props.globals.addSuccess('Hírlevél sikeresen módosítva!');
          this.setState({
            saveButtonLoading: false
          }, () => {
            this.toggleFormModal();
            this.listHirlevelek(null, null)
          });
        } else {
          this.setState({
            saveButtonLoading: false,
            // currentId: undefined
          });
        }
      });
    }

    if(this.state.currentId) {
      for(const src of this.state.deletedImages) {
        Services.deleteEditorImage(this.state.currentId, src.split('/').at(-1), () => {});
      }
    }
  }

  submitTesztForm = () => {
    let id = this.state.currentTesztkuldesId;
    Services.tesztKuldes(id, this.state.formTesztEmail, (err) => {
        if (!err) {
          this.props.globals.addSuccess('Teszt email sikeresen elküldve!');
          this.setState({
            saveButtonLoading: false
          }, () => {
            this.toggleTesztModal();
            this.listHirlevelek(null, null)
          });
        } else {
          this.setState({
            saveButtonLoading: false
          });
        }
    })
  }

  submitSendForm = (muvelet) => {
    const { formAutomata, selectedKategoriak, currentId } = this.state;
    let submitObj = {};
    submitObj.id = currentId
    submitObj.utemezettkuldes = formAutomata ? this.dateToTimezone(formAutomata) : null;
    submitObj.kategoriak = selectedKategoriak.map(kategoria => ({ kid: kategoria.kid, hid: kategoria.hid }));;
    this.setState({ cimzettButtonLoading: false });
    if (muvelet === 'save') {
      Services.saveHirlevelCimzett(submitObj, (err) => {
        if (!err) {
          this.toggleSendModal();
          this.setState({ cimzettButtonLoading: false });
          this.props.globals.addSuccess('Címzettek sikeresen elmentve!');
          this.listHirlevelek(null, null)
        } else {
          this.setState({ cimzettButtonLoading: false });
        }
      });
    }
    if (muvelet === 'send') {
      Services.saveAndSendHirlevelCimzett(submitObj, (err) => {
        if (!err) {
          this.toggleCimzettCount();
          this.toggleSendModal();
          this.setState({ cimzettSaveButtonLoading: false })
          this.props.globals.addSuccess('Hírlevél sikeresen elküldve!');
          this.listHirlevelek(null, null);
        } else {
          this.setState({ cimzettSaveButtonLoading: false })
        }
      })
    }
  }

  calculatePercentage = (numerator, denominator) => {
    if (!denominator || !numerator)
      return 0;
    return removeRedundantZeros((numerator / denominator * 100).toFixed(2));
  }

  tableIconFormatter = (cell, row) => {
    return (
      <>
          {this.hasRole(['HIRLEVEL_HIRLEVEL']) && 
            <>
              <Button className="icon-eye table-action-icon" id={'action-view-' + cell + 'megtekintes'} onClick={() => this.handleViewClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
              <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'megtekintes'} delay={50}>
                {'Megtekintés'}
              </UncontrolledTooltip>
              <React.Fragment hidden={!row.utolsokuldesidopont}>
              <Button className="icon-list table-action-icon" id={'action-view-' + cell + 'cimzett'} onClick={() => { this.handleCimzettMegtekintesClick(cell);}} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
              <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'cimzett'} delay={50}>
                {'Címzettek megtekintése'}
              </UncontrolledTooltip>
              </React.Fragment>
            </>
          }
          {this.hasRole(['HIRLEVEL_HIRLEVEL'], true) && 
            <>
              <React.Fragment hidden={row.utolsokuldesidopont}>
                <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleEditClick(cell, false)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'modositas'} delay={50}>
                  {'Módosítás'}
                </UncontrolledTooltip>
              </React.Fragment>
                <Button className="icon-refresh table-action-icon" id={'action-view-' + cell + 'refresh'} onClick={() => { this.handleEditClick(cell, true)}} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'refresh'} delay={50}>
                  {'Újként megnyitás'}
                </UncontrolledTooltip>
                <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'torles'} onClick={() => this.handleDeleteClick(cell)} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'torles'} delay={50}>
                  {'Törlés'}
                </UncontrolledTooltip>
            </>
          }
          {this.hasRoleSpec(['HIRLEVEL_HIRLEVEL_KULD']) && this.hasRole(['HIRLEVEL_HIRLEVEL'], true) && 
            <>
                <Button className="icon-share-alt table-action-icon" id={'action-send-' + cell + 'test'} onClick={() => { this.handleTesztClick(cell) }} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-send-' + cell + 'test'} delay={50}>
                  {'Teszt küldés'}
                </UncontrolledTooltip>
                <Button className="icon-envelope table-action-icon" id={'action-view-' + cell + 'kuldes'} onClick={() => { this.handleSendClick(cell) }} onMouseDown={(e) => { if (e) { e.preventDefault(); } }} />
                <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + 'kuldes'} delay={50}>
                  {'Küldés'}
                </UncontrolledTooltip>
            </>
          }
      </>
    );
  }

  renderFormTitle = () => {
    switch (this.state.formType) {
      case 'FEL':
        return 'Új hírlevél létrehozása';
      case 'MOD_NEW':
        return 'Új hírlevél létrehozása';
      case 'MOD':
        return 'Hírlevél módosítása';
      case 'VIEW':
        return 'Hírlevél adatai';
      default:
        return '';
    }
  }

  renderTable = () => {
    const columns = [
      {
        dataField: 'azonosito',
        text: 'Azonosító',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordWrap: 'break-word',
          // wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'rogzidopont',
        text: 'Létrehozás időpontja',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        formatter: this.timezoneToDate,
        filterValue: this.timezoneToDate,
        sort: true
      },
      {
        dataField: 'kategoria',
        text: <>Kategória<CustomTooltip text={getTooltip('kategoria')} id="kategoriaTT" /></>,
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'nev',
        text: 'Név',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordWrap: 'break-word',
          // wordBreak: 'break-word',
        },
        sort: true
      },
      {
        dataField: 'targy',
        align: 'center',
        text: 'Tárgy',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordWrap: 'break-word',
          // wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        }
      },
      {
        dataField: 'utolsokuldesidopont',
        align: 'center',
        text: 'Utolsó küldés időpontja',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        formatter: this.timezoneToDate,
      },
      {
        dataField: 'moduser',
        align: 'center',
        text: 'Utolsó módosító',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordWrap: 'break-word',
          whiteSpace: 'pre-line',
        },
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        hidden: !this.hasRole(['HIRLEVEL_HIRLEVEL']) && !this.hasRoleSpec(['HIRLEVEL_HIRLEVEL_KULD']),
        formatter: this.tableIconFormatter
      }
    ];
  
    return (
      <div className="animated fadeIn">
        <BootstrapTable
          bootstrap4
          keyField="id"
          data={this.state.baseJson}
          columns={columns}
          wrapperClasses="table-responsive"
          classes="table-scroll"
          headerClasses="table-th"
          filter={filterFactory()}
          pagination={paginationFactory(Lib.bootstraptableProps)}
          noDataIndication="Nincs megjelenítendő adat!"
        />
      </div>
    );
  }

  // validateDate = (inputid, labelid) => {
  //   let input = document.getElementById(inputid);
  //   let label = document.getElementById(labelid);
  //   console.log(!this.state.formAutomata && this.state.formKuldesKategoriak.length !== 0)
  //   if (!this.state.formAutomata && this.state.formKuldesKategoriak.length !== 0) {
  //     input.style.borderColor = 'red';
  //     label.style.color = "red"
  //     this.setState({ hasValue: false })
  //   } else {
  //     input.style.borderColor = 'grey';
  //     label.style.color = "black"
  //     this.setState({ hasValue: true })
  //   }
  // }

  renderSendData = () => {
    const { formAutomata, selectedKategoriak } = this.state;
    return (
      <RFForm onSubmit={() => {}}>
        <div className="row">
         <div className="col-md-12">
          <h6>
            {'Hírlevél neve: '}<span style={{ fontWeight: 400 }}>{this.state.sendData.nev}</span>
          </h6>
         </div>
        </div>
        <br />
        <div className="row">
        <div className="col-md-6">
            <SelectField
              label='Kategória választás:'
              value={[]}
              name="formKuldesKategoriak"
              // styles={styles}
              // isMulti
              onChange={this.handleKuldesKategoriaChange}
              styles={{
                control: (base, state) => ({
                  ...base,
                  '&:focus': { borderColor: 'red' }, // border style on hover
                  border: '1px solid lightgray', // default border color
                  boxShadow: 'none', // no box-shadow
                  borderRadius: '0'
                }),
              }}
              placeholder="Választás..."
              options={this.state.kategoriak}
              isOptionDisabled={option => option.ckd === 'KULD'}
              formatOptionLabel={this.formatOptionLabel}
              formatGroupLabel={this.formatGroupLabel}
            />
          </div>
          <div className="col-md-6">
            <DatetimePicker
              label={'Időzített küldés időpontja: '}
              containerClassName="organw-date-time"
              // format="YYYY-MM-DD HH:mm:ss"
              
              // onBlur={() => this.validateDate('formAutomata', 'automatalabel')}
              // onMouseDown={() => this.validateDate('formAutomata', 'automatalabel')}
              messages={{ dateButton: 'dátum', timeButton: 'idő' }}
              //onChange={this.handleDateInputChange}
              onChange={(e,v) => {this.handleDateChange(e,v,'FORMIDOZITETTKULDES')}}
              onSelect={(e,v) => { this.selected = true }}
              name="formAutomata"
              id="formAutomata"
              disabled={selectedKategoriak.length === 0}
              value={formAutomata && new Date(formAutomata)}
              timePrecision="seconds"
            />
            {/* <div hidden={hasValue} style={{ color: "red" }}>Ez a mező kitöltése kötelező</div> */}
          </div>
        </div>
        <div className="row">
          {this.renderCategoryCards()}
        </div>
      </RFForm>
    );
  }

  formatGroupLabel = data => {
    let dbCounter = 0;
    this.state.selectedKategoriak.filter(kategoria => kategoria.hid == data.hid).forEach(kategoria => {
      dbCounter += kategoria.db;
    });
    return (
    <div className='row m-0 align-items-center'>
      {this.formatLabelCircle(dbCounter)}
      <div className='col'>
        {data.label}
      </div>
    </div>
  )}

  formatLabelCircle = (child) => {
    return <div className='col-auto' style={{
      backgroundColor: '#EBECF0',
      borderRadius: '2em',
      color: '#172B4D',
      display: 'inline-block',
      fontSize: 12,
      fontWeight: 'normal',
      minWidth: 1,
      padding: '0.16666666666667em 0.5em',
      textAlign: 'center',
    }}
    >
      {child}
    </div>
  }

  formatOptionLabel = data => {
    let isSelected = this.state.selectedKategoriak.includes(data);
    let checkIcon = <i className={isSelected ? "fa fa-check" : "fas fa-minus"} aria-hidden="true" style={{color: !isSelected && '#b2bed7'}} />;
    return (
    <div className='row m-0 ml-1'>
      {this.formatLabelCircle(data.db)}
      <div className='col'>
        {data.nev}
      </div>
      {this.formatLabelCircle(checkIcon)}
    </div>
  )}

  renderCategoryCards = () => {
    // KID-hez mappol egy objektumot, ami tartalmazza a rendereléshez szükséges kategória adatokat, valamint a helyszíneket, amikhez ki lett választva a kategória
    let kategoriaIdToRenderObjectMap = {};
    this.state.selectedKategoriak.forEach(kategoriaNew => {
      // Ha új a kategória (első felhasználás a tömb bejárásakor), akkor csak az ami statikus és szükséges adat kerül elmentésre a renderObj-ba, egyébként meglévő renderObj-t módosít
      let kategoria = kategoriaIdToRenderObjectMap[kategoriaNew.kid] || { kid: kategoriaNew.kid, nev: kategoriaNew.nev, ckd: kategoriaNew.ckd };
      // Ha nem létezett eddig ez a kategória, akkor belerakja kategoriaIdToRenderObjectMap-ba, egyébként meg felülírja a memóriacímet önmagával, hogy lehessen egységesen hivatkozni rá
      // (ilyenkor nem csinál semmit, csak nem kell rá feltétel, hogy csak akkor töltse ha üres)
      kategoriaIdToRenderObjectMap[kategoriaNew.kid] = kategoria;
      // A kategoria a kategoriaIdToRenderObjectMap-es kategóriára mutat, ami kid-nként egyedi. A kategoriaNew az új kategóriára mutat mindig a map-elés folyamatban, ami mentén a for megy
      let hidArray = kategoria.hidArray || [];
      let hnevArray = kategoria.hnevArray || [];
      let dbCounter = kategoria.dbCounter || 0;
      if (!hidArray.includes(kategoriaNew.hid)) {
        hidArray.push(kategoriaNew.hid);
        hnevArray.push(kategoriaNew.hnev);
        dbCounter += kategoriaNew.db;
      }
      kategoria.hidArray = hidArray;
      kategoria.hnevArray = hnevArray;
      kategoria.dbCounter = dbCounter;
      // Ha bármelyik helyszínnél a kategória még nem lett elküldve, akkor mutatható a törlés gomb és ilyenkor a "nem-küldötteket" kell csak törölni
      if (kategoriaNew.ckd != 'KULD')
        kategoria.torolheto = true;
    });

    return Object.values(kategoriaIdToRenderObjectMap).map((kategoria, index) => {
        return (
          <div className="col-lg-3 col-md-6 col-sm-6 col-12" key={kategoria.nev + index}>
            <Card body inverse color="success" style={{ height: "240px" }}>
              <i className="fa fa-info-circle" id={'hely' + index} style={{ position: 'relative', left: '95%', top: '1%', width: '30px' }} aria-hidden="true" />
              <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'right' }} placement="bottom" target={'hely' + index} delay={50}>
                {kategoria.hnevArray.join(", ")}
              </UncontrolledTooltip>
              <CardTitle className="col text-center">
                <h4>
                  {kategoria.nev}
                  <br />
                  {kategoria.dbCounter + ' aktuális feliratkozó'}
                </h4>
              </CardTitle>
              <div className="row">
                <div className="col text-center" style={{ position: 'absolute', left: '0px', top: '80%' }} hidden={!kategoria.torolheto}>
                  <Button style={{ width: '100%' }} color="danger" onClick={() => this.handleKategoriaTorlesClick(kategoria)}>
                    <i className="fa fa-trash" style={{ marginRight: 5 }} aria-hidden="true" />
                    Törlés
                  </Button>
                </div>
              </div>
            </Card>
          </div>
        );
      })
  }

  submitCimzettSzuro = () => {
    const { currentId, szurHelyszin, szurKategoria, szurEmail } = this.state;
    let submitObj = {};
    submitObj.id = parseInt(currentId, 10);
    submitObj.helyszinid = parseInt(szurHelyszin, 10);
    submitObj.kategoriaid = parseInt(szurKategoria, 10);
    submitObj.email = szurEmail;
    Services.getCimzettek(submitObj, (err, res) => {
      if (!err) {
      let result = res[0]
        result.forEach((e) => {
          e.k = e.k && this.timezoneToDate(e.k)
          e.m = e.m && this.timezoneToDate(e.m)
        })
        this.setState({ cimzettekBaseJson: result });
      }
    })
  }


  renderCimzettek = () => {
    const { szurHelyszin, szurKategoria, szurEmail } = this.state;
    return (
      <div className="col-md-12">
      <div className="row">
        <div className="col-md-3">
          <RFField
            name="szurHelyszin"
            required={szurKategoria ? false : true}
            type="select"
            onChange={this.handleInputChange}
            value={szurHelyszin}
            label={"Helyszín: " + (szurKategoria ? '' : '*')}
            defaultSelect={<option key="" value="">Válassz helyszínt...</option>}
            selectOptions={this.state.szurHelyszinekOptions}
          />
         </div>
        <div className="col-md-3">
          <RFField
            name="szurKategoria"
            required={szurHelyszin ? false : true}
            type="select"
            onChange={this.handleInputChange}
            value={szurKategoria}
            label={"Kategória: " + (szurHelyszin ? '' : '*')}
            defaultSelect={<option key="" value="">Válassz kategóriát...</option>}
            selectOptions={this.state.szurKategoriakOptions}
          />
        </div>
        <div className="col-md-3">
          <RFField
            label="Email: "
            name="szurEmail"
            id="szurEmail"
            type="text"
            onChange={this.handleInputChange}
            value={szurEmail}
          />
        </div>
        <div className="col-md-2">
            <Button
              style={{ position: 'relative', top: '28px' }}
              onClick={() => {
                if ((szurHelyszin || szurKategoria) ) {
                  this.setState({ isFiltered: true })
                }
                this.submitCimzettSzuro()
              }}
              color="success"
            >
              Keresés
            </Button>
          </div>
          <br />
          <div className="col-md-12" hidden={!this.state.isFiltered}>
            {this.renderCimzettekTable()}
          </div>
        </div>
      </div>
    );
  }


  renderCimzettekTable = () => {
    const options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ],
    };

    const columns = [
      {
        dataField: 'e',
        text: 'Email',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'k',
        text: 'Küldés időpontja',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'm',
        text: 'Megtekintés időpontja',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          wordBreak: 'break-all',
          whiteSpace: 'pre-line',
        },
        sort: true
      },
      {
        dataField: 'e',
        text: 'Műveletek',
        hidden:true,
      }
    ];

    return (
      <div className="animated fadeIn">
        <BootstrapTable
          bootstrap4
          keyField="id"
          data={this.state.cimzettekBaseJson}
          columns={columns}
          wrapperClasses="table-responsive"
          classes="table-scroll"
          headerClasses="table-th"
          filter={filterFactory()}
          pagination={paginationFactory(Lib.bootstraptableProps)}
          noDataIndication="Nincs megjelenítendő adat!"
        />
      </div>
    );
  }

  render() {
    return (
      <React.Fragment>
        <div className="row" style={{ alignContent: 'center' }}>
          <div className="col-md-12">
            {this.hasRole(['HIRLEVEL_HIRLEVEL'], true) && (
            <Button className="pull-left table-new-button" color="primary" onClick={this.handleNewClick}>
              {'Új hírlevél'}
            </Button>
            )}
          </div>
          {/* <div className="col-md-12" /> */}
          <div className="col-md-12">

            {this.renderEloszuresForm()}

          </div>
          <div className="col-md-12" />
          <div className="col-md-12">
            {{
              LOAD: (<Loader />),
              DATA: (<DataEmptyState
                hasImage
                subtitle="Vigyél fel új tételt!"
              />),
              NETW: (<NetworkEmptyState
                hasImage
                submitClick={() => { this.listHirlevelek(null, null); }}
              />),
              TABL: (this.renderTable())
            }[this.state.tableStatus]}
          </div>
        </div>
        <Modal isOpen={this.state.modalForm} toggle={this.toggleFormModal} backdrop="static" size="lg" style={{ overflowY: 'hidden', minHeight: '600px' }} unmountOnClose>
          <ModalHeader>{this.renderFormTitle()}</ModalHeader>
          <RFForm>
            <ModalBody>
              <div className="row">
                <div className="col-md-12">
                  {this.renderForm()}
                  {this.renderTartalomForm()}
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              {this.hasRole(['HIRLEVEL_HIRLEVEL'], true) && (
                <ProgressButton
                  className="btn-cursor-pointer"
                  color="primary"
                  loading={this.state.saveButtonLoading}
                  onClick={() => {
                    // let valtozok = [];
                    // this.state.toolbargroupjegy.forEach((jegy, index) => {
                    //   this.state.selectedJegy.forEach((selected, idx) => {
                    //     if (selected.name === jegy.nam && selected.checked)
                    //       valtozok.push(selected.name);
                    //   });
                    // });
                    this.submitForm();
                  }}
                >
                  Mentés
                </ProgressButton>
              )}
              {' '}
              <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.handleFormCancel}>Mégsem</Button>
            </ModalFooter>
          </RFForm>
        </Modal>
        <Modal isOpen={this.state.modalView} toggle={this.toggleViewModal} backdrop="static" size="lg" unmountOnClose>
          <ModalHeader>{this.renderFormTitle()}</ModalHeader>
          <ModalBody>
            <div className="row">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-8 offset-md-2">
                    <Table bordered responsive>
                      <tbody>
                        <tr>
                          <td style={{ border: '0px' }}><b><u>Létrehozva:</u></b></td>
                          <td style={{ border: '0px' }}>{this.state.viewObj && this.state.viewObj.rogzidopont && this.timezoneToDate(this.state.viewObj.rogzidopont)}</td>
                          <td style={{ border: '0px' }}><b><u>Létrehozta:</u></b></td>
                          <td style={{ border: '0px' }}>{this.state.viewObj && this.state.viewObj.rogzuser && this.state.viewObj.rogzuser}</td>
                        </tr>
                        <tr>
                          <td style={{ border: '0px' }}><b><u>Utolsó küldés időpontja:</u></b></td>
                          <td style={{ border: '0px' }}>{this.state.viewObj && this.state.viewObj.utolsokuldesidopont && this.timezoneToDate(this.state.viewObj.utolsokuldesidopont)}</td> 
                          <td style={{ border: '0px' }}><b><u>Küldő:</u></b></td>
                          <td style={{ border: '0px' }}>{this.state.viewObj && this.state.viewObj.kulduser && this.state.viewObj.kulduser}</td>
                        </tr>
                        <tr>
                          <td style={{ border: '0px' }}><b><u>Utolsó módosítás:</u></b></td>
                          <td style={{ border: '0px' }}>{this.state.viewObj && this.state.viewObj.modidopont && this.timezoneToDate(this.state.viewObj.modidopont)}</td>
                          <td style={{ border: '0px' }}><b><u>Módosító:</u></b></td>
                          <td style={{ border: '0px' }}>{this.state.viewObj && this.state.viewObj.moduser && this.state.viewObj.moduser}</td>
                        </tr>
                        <tr>
                          <td style={{ border: '0px' }} />
                          <td style={{ border: '0px' }} />
                          <td style={{ border: '0px' }} />
                          <td style={{ border: '0px' }} />
                        </tr>
                        <tr>
                          <td style={{ border: '0px' }}><b><u>Név:</u></b></td>
                          <td style={{ border: '0px' }}>{this.state.viewObj && this.state.viewObj.nev && this.state.viewObj.nev}</td>
                          <td style={{ border: '0px' }} />
                          <td style={{ border: '0px' }} />
                        </tr>
                        <tr>
                          <td style={{ border: '0px' }}><b><u>Kategória:</u></b></td>
                          <td style={{ border: '0px' }}>{this.state.viewObj && this.state.viewObj.kategoria && this.state.viewObj.kategoria}</td>
                          <td style={{ border: '0px' }} />
                          <td style={{ border: '0px' }} />
                        </tr>
                        <tr>
                          <td style={{ border: '0px' }}><b><u>Tárgy:</u></b></td>
                          <td style={{ border: '0px' }}>{this.state.viewObj && this.state.viewObj.targy && this.state.viewObj.targy}</td>
                          <td style={{ border: '0px' }} />
                          <td style={{ border: '0px' }} />
                        </tr>
                        <tr>
                          <td style={{ border: '0px' }} />
                          <td style={{ border: '0px' }} />
                          <td style={{ border: '0px' }} />
                          <td style={{ border: '0px' }} />
                        </tr>
                        <tr>
                          <td style={{ border: '0px' }}><b><u>Címzettek száma:</u></b></td>
                          <td style={{ border: '0px' }}>{this.state.viewObj.cimzettszam + ' (Elküldve: ' + this.state.viewObj.elkuldottszam + ', ' + this.calculatePercentage(this.state.viewObj.elkuldottszam, this.state.viewObj.cimzettszam) + '%)'}</td>
                          <td style={{ border: '0px' }}><b><u>Megtekintve:</u></b></td>
                          <td style={{ border: '0px' }}>{this.state.viewObj.megtekintesszam + ' (' + this.calculatePercentage(this.state.viewObj.megtekintesszam, this.state.viewObj.elkuldottszam) + '%)'}</td>
                        </tr>
                      </tbody>
                    </Table>
                    <Wysiwyg
                      key={this.state.viewObj.tartalom}
                      value={this.state.viewObj.tartalom}
                      readOnly
                      toolbar={null}
                    />
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.toggleViewModal}>OK</Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.modalDelete} toggle={this.toggleDeleteModal} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>Valóban törölni kívánod a kiválasztott tételt?</ModalBody>
          <ModalFooter>
            <ProgressButton
              className="btn-cursor-pointer"
              color="primary"
              onClick={() => this.deleteHirlevel()}
              loading={this.state.deleteButtonLoading}
            >
              {'Igen'}
            </ProgressButton>
            <Button type="button" color="secondary" onClick={this.toggleDeleteModal}>Mégsem</Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.modalSend} toggle={this.toggleSendModal} backdrop="static" size="lg">
          <ModalHeader>Címzettek kiválasztása</ModalHeader>
          <ModalBody>
            {{
              LOAD: (<Loader />),
              NETW: (<NetworkEmptyState
                hasImage
                submitClick={() => { this.getHirlevelCimzettInit(this.state.currentId); }}
              />),
              TABL: (this.renderSendData())
            }[this.state.sendStatus]}
            <Modal isOpen={this.state.modalSendNested} backdrop="static" size="sm">
              <ModalHeader>Küldés</ModalHeader>
              <ModalBody>
                {'Elküldi a hírlevelet '}
                {this.state.cimzettSzam}
                {' címzettnek?'}
              </ModalBody>
              <ModalFooter>
                <ProgressButton
                  className="btn-cursor-pointer"
                  color="success"
                  onClick={() => {
                    this.setState({
                      cimzettSaveButtonLoading: true,
                    });
                    this.submitSendForm('send')
                  }}
                  loading={this.state.cimzettSaveButtonLoading}
                >
                  {'Küldés'}
                </ProgressButton>
                {' '}
                <Button
                  color="secondary"
                  onClick={() => {
                    this.toggleCimzettCount();
                  }}
                >
                  Mégsem
                </Button>
              </ModalFooter>
            </Modal>
          </ModalBody>
          <ModalFooter>
            <ProgressButton
              className="btn-cursor-pointer"
              color="primary"
              onClick={() => {
                this.setState({
                  cimzettButtonLoading: true
                });
                this.submitSendForm('save');
              }}
              // disabled={this.state.formKuldesKategoriak.length === 0}
              loading={this.state.cimzettButtonLoading}
            >
              {'Mentés'}
            </ProgressButton>
            <ProgressButton
              className="btn-cursor-pointer"
              color="success"
              onClick={() => {
                this.getCimzettCount();
              }}
              // disabled={this.state.formKuldesKategoriak.length === 0 || this.state.formAutomata}
              loading={this.state.cimzettButtonLoading}
            >
              {'Küldés'}
            </ProgressButton>
            <Button type="button" color="secondary" onClick={this.toggleSendModal}>Mégsem</Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.modalCimzettMegtekines} toggle={this.toggleCimzettMegtekines} backdrop="static" size="lg">
          <RFForm
            modal
            onSubmit={this.submitCimzettSzuro}
            title={<>Címzettek megtekintése<CustomTooltip text={getTooltip('cimzettek')} id="cimzettekTT" /></>}
            footer={
              <React.Fragment>
                <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={() => { this.toggleCimzettMegtekines(); this.setState({ szurHelyszin: null, szurKategoria: null, szurEmail: '', isFiltered: false, cimzettekBaseJson: [] }) }}>OK</Button>
              </React.Fragment>
            }
          >
            <div className="row">
              {this.renderCimzettek()}
            </div>
          </RFForm>
        </Modal>
        <Modal isOpen={this.state.modalTestSend} toggle={this.toggleTesztModal} backdrop="static" size="sm">
          <RFForm
            modal
            onSubmit={this.submitTesztForm}
            title={"Teszt küldés"}
            footer={
              <React.Fragment>
                {this.hasRole(['HIRLEVEL_HIRLEVEL'], true) && (
                  <ProgressButton
                    className="btn-cursor-pointer"
                    color="primary"
                    loading={this.state.saveButtonLoading}
                    // onClick={() => { this.submitTesztForm();}}
                  >
                    Küldés
                  </ProgressButton>
                )}
                {' '}
                <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={() => { this.toggleTesztModal(); this.setState({ formTesztEmail: '' });}}>Mégsem</Button>
              </React.Fragment>
            }
          >
            <RFField
              type="text"
              label="Teszt email cím: *"
              name="formTesztEmail"
              id="formTesztEmail"
              required
              onChange={this.handleInputChange}
              value={this.state.formTesztEmail}
            />
          </RFForm>
        </Modal>
      </React.Fragment>
    );
  }
}

HirlevelKezeles.propTypes = {
  globals: PropTypes.object,
  active: PropTypes.bool,
};

export default HirlevelKezeles;
